// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as DisputesRouteImport } from './routes/disputes'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SequenceRouteImport } from './routes/sequence'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as YardRouteImport } from './routes/yard'
import { Route as AuthCallbackRouteImport } from './routes/auth_.callback'
import { Route as DisputesIndexRouteImport } from './routes/disputes.index'
import { Route as DisputesDisputeIdRouteImport } from './routes/disputes.$disputeId'
import { Route as SettingsBillingRouteImport } from './routes/settings_.billing'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AnalyticsRoute = AnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const DisputesRoute = DisputesRouteImport.update({
            id: '/disputes',path: '/disputes',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SequenceRoute = SequenceRouteImport.update({
            id: '/sequence',path: '/sequence',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const YardRoute = YardRouteImport.update({
            id: '/yard',path: '/yard',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth_/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const DisputesIndexRoute = DisputesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DisputesRoute
          })
const DisputesDisputeIdRoute = DisputesDisputeIdRouteImport.update({
            id: '/$disputeId',path: '/$disputeId',getParentRoute: () => DisputesRoute
          })
const SettingsBillingRoute = SettingsBillingRouteImport.update({
            id: '/settings_/billing',path: '/settings/billing',getParentRoute: () => rootRouteImport
          })





const DisputesRouteChildren = {
  DisputesDisputeIdRoute: DisputesDisputeIdRoute,DisputesIndexRoute: DisputesIndexRoute
}

const DisputesRouteWithChildren = DisputesRoute._addFileChildren(DisputesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AnalyticsRoute: AnalyticsRoute,AuthRoute: AuthRoute,DisputesRoute: DisputesRouteWithChildren,OnboardingRoute: OnboardingRoute,PrivacyRoute: PrivacyRoute,SequenceRoute: SequenceRoute,SettingsRoute: SettingsRoute,TermsRoute: TermsRoute,YardRoute: YardRoute,AuthCallbackRoute: AuthCallbackRoute,SettingsBillingRoute: SettingsBillingRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)